import { useMutation } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { initiateRingout } from "./api"

export function useInitiateRingout() {
  const getContext = useApiContext()

  return useMutation({
    mutationFn: async (params: {
      integrationId: string
      integrationType: string
      toPhone: string
      inboxPhone?: string
    }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return initiateRingout(context, params)
    },
    meta: { errorToast: { fallback: "Failed to initiate call" } },
  })
}
